import { Header } from '@/payload-types'
import { getCMSLinkHref } from '@/utilities/getCMSLinkHref'

export function isSectionActive(pathname: string, data: NonNullable<Header['sections']>[number]) {
  return data?.items?.some((item) => {
    const href = getCMSLinkHref(item.link)
    if (!href) return false
    return pathname.startsWith(href)
  })
}

export function isLinkActive(pathname: string, data: NonNullable<Header['links']>[number]) {
  if (
    data.link.reference &&
    typeof data.link.reference.value !== 'number' &&
    data.link.reference.value.slug
  ) {
    const href = getCMSLinkHref(data.link)
    if (!href) return false
    return pathname.startsWith(href)
  }
  return false
}
